//引入VueRouter
import VueRouter from 'vue-router'
import Vue from "vue";

//引入路由组件
import MainOperatePage from "../pages/newCreate/MainOperatePage"
import PcLogin from "../pages/login/PcLogin"
import UserCenter from "../pages/userCenter/UserCenter"
import LoginCompanySelect from "../pages/login/LoginCompanySelect"
import UserRegister from "../pages/login/UserRegister"
import appPrompt from "../pages/userCenter/appPrompt"
import ForgetPassword from "../pages/login/ForgetPassword"
// import RegisterCompany from "@/pages/userCenter/ChildPage/RegisterCompany/RegisterCompany"
import RegisterState from "@/pages/userCenter/ChildPage/RegisterState/RegisterState";
import CompanyApplyList from "@/pages/userCenter/ChildPage/CompanyApplyList/CompanyApplyList"
import PermissionCompanyList from "@/pages/userCenter/ChildPage/PermissionCompanyList/PermissionCompanyList"
import SelectCompany from "@/pages/userCenter/ChildPage/SelectCompany/SelectCompany"
import PromoteList from "../pages/userCenter/ChildPage/PromoteList/PromoteList"
import UserInfo from "@/pages/userCenter/ChildPage/UserInfo/UserInfo";
import FeedBack from "@/pages/userCenter/ChildPage/FeedBack/FeedBack";
import CompanyInformation from "@/pages/userCenter/ChildPage/CompanyInformation/CompanyInformation";
import MapWindow from "@/pages/redirectWindows/MapWindow";
import AlertWindow from "@/pages/redirectWindows/AlertWindow";
import HisWindow from "@/pages/redirectWindows/HisWindow";
import createWindow from "@/pages/redirectWindows/CreateWindow";
import AfterScan from "@/pages/login/AfterScan";
import RedirectToCreate from "@/pages/redirectWindows/RedirectToCreate";
import defaultCreate from "@/pages/redirectWindows/defaultCreate";
//创建router实例对象，去管理一组一组的路由规则
var router = new VueRouter({
	mode: "history",
	base: "/front/",
	routes:[
		{ // 配置默认路由
			path:"/", // 路由地址
			redirect:"/pages/login/PcLogin" ,// 重定向
			meta: {
				headerHidden: true
			},
		},
		{
			path:'/pages/login/PcLogin',   //路径是/about结尾时，渲染相应的组件
			component: PcLogin,
			meta: {
				headerHidden: true
			},
		},
		{
			path:'/pages/MainOperatePage',
			component:MainOperatePage
		},
		{
			path:"/pages/redirect/map",
			component: MapWindow
		},
		{
			path:"/pages/redirect/alert",
			component: AlertWindow
		},
		{
			path:"/pages/redirect/history",
			component: HisWindow
		},
		{
			path:"/pages/redirect/create",
			component: createWindow
		},
		{
			path:"/pages/redirect/defaultCreate",
			component: defaultCreate
		},
		{
			path:"/pages/userCenter/appPrompt",
			component: appPrompt
		},
		{
			path:'/pages/userCenter/UserCenter',   //路径是/about结尾时，渲染相应的组件
			component: UserCenter,
			children: [
				{
					path: 'RegisterState',
					component: RegisterState,
				},
				{
					path: 'SelectCompany',
					component: SelectCompany,
				},
				{
					path: 'CompanyApplyList',
					component: CompanyApplyList,
				},
				{
					path: 'PermissionCompanyList',
					component: PermissionCompanyList,
				},
				{
					path: 'PromoteList',
					component: PromoteList,
				},
				{
					path: 'UserInfo',
					component: UserInfo,
				},
				{
					path: 'FeedBack',
					component: FeedBack,
				},
				{
					path: 'CompanyInformation',
					component: CompanyInformation,
				},
			]
		},
		{
			path:'/pages/login/LoginCompanySelect',
			component: LoginCompanySelect,
			meta: {
				headerHidden: true
			},
		},
		{
			path:'/pages/login/UserRegister',
			component: UserRegister,
			meta: {
				headerHidden: true
			},
		},
		{
			path:'/pages/login/ForgetPassword',
			component: ForgetPassword,
			meta: {
				headerHidden: true
			},
		},
		{
			path:'/pages/login/AfterScan',
			component: AfterScan,
		},
		{
			path:'/pages/redirect/redirect',
			component: RedirectToCreate,
		},
	]
})

router.beforeEach(async (to, from, next) => {
	if(to.meta.headerHidden || window.localStorage.getItem("isApp")==="1") {
		Vue.prototype.$showHeader = false
	} else {
		Vue.prototype.$showHeader = true
	}
	next()
})
export default router;